<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading"><span class="smallcaps">ALSO BY<br/>JANE GARDAM</span></h1>
<p class="center">F<span class="smallcaps">ICTION</span></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609451417/a-long-way-from-verona" target="_blank">A Long Way From Verona</a></em></p>
<p class="center"><em class="italic">The Summer After the Funeral</em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609453312/bilgewater" target="_blank">Bilgewater</a></em></p>
<p class="center"><em class="italic">Black Faces, White Faces</em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372761/god-on-the-rocks" target="_blank">God on the Rocks</a></em></p>
<p class="center"><em class="italic">The Sidmouth Letters</em></p>
<p class="center"><em class="italic">The Pangs of Love and Other Stories</em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609450694/crusoe-s-daughter" target="_blank">Crusoe’s Daughter</a></em></p>
<p class="center"><em class="italic">Showing the Flag</em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372365/the-queen-of-the-tambourine" target="_blank">The Queen of the Tambourine</a></em></p>
<p class="center"><em class="italic">Missing the Midnight</em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609454050/the-flight-of-the-maidens" target="_blank">The Flight of the Maidens</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372136/old-filth" target="_blank">Old Filth</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372563/the-people-on-privilege-hill" target="_blank">The People on Privilege Hill</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372891/the-man-in-the-wooden-hat" target="_blank">The Man in the Wooden Hat</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609450939/last-friends" target="_blank">Last Friends</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609453442/the-stories-of-jane-gardam" target="_blank">The Stories</a></em></p>
<p class="center"> </p>
<p class="center">F<span class="smallcaps">OR CHILDREN</span></p>
<p class="center"><em class="italic">Bridget and William</em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452469/the-hollow-land" target="_blank">The Hollow Land</a></em></p>
<p class="center"><em class="italic">A Fair Few Days</em></p>
<p class="center"> </p>
<p class="center">N<span class="smallcaps">ONFICTION</span></p>
<p class="center"><em class="italic">The Iron Coast</em></p>
<p class="center"> </p>
<p class="center">I<span class="smallcaps">LLUSTRATED</span></p>
<p class="center"><em class="italic">The Green Man</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// faith-fox_00000.vue?770aa3f2